module.exports = __webpack_public_path__ + "assets/img/logo.ae87779e.svg";